import { GlModal } from '@gitlab/ui';
import { translate } from '../../../../../utils/i18n';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  TITLE: translate('AgenticToolApprovalModal.title', 'Tool Approval Required'),
  DEFAULT_DESCRIPTION: translate('AgenticToolApprovalModal.defaultDescription', 'GitLab Duo Agentic Chat wants to execute a tool. Do you want to proceed?'),
  TOOL_LABEL: translate('AgenticToolApprovalModal.toolLabel', 'Tool:'),
  TOOL_UNKNOWN: translate('AgenticToolApprovalModal.toolUnknown', 'Unknown'),
  APPROVE_TEXT: translate('AgenticToolApprovalModal.approveText', 'Approve'),
  DENY_TEXT: translate('AgenticToolApprovalModal.denyText', 'Deny')
};
var script = {
  name: 'AgenticToolApprovalModal',
  components: {
    GlModal
  },
  props: {
    /**
     * Controls the visibility of the modal
     */
    visible: {
      type: Boolean,
      required: true
    },
    /**
     * Details about the tool to be executed
     * @property {string} name - The name of the tool
     * @property {Object} parameters - The parameters to be passed to the tool
     */
    toolDetails: {
      type: Object,
      required: false,
      default: () => ({}),
      validator: value => {
        return typeof value === 'object' && value !== null;
      }
    },
    /**
     * Custom description text for the approval request
     */
    description: {
      type: String,
      required: false,
      default: i18n.DEFAULT_DESCRIPTION
    }
  },
  computed: {
    approveAction() {
      return {
        text: this.$options.i18n.APPROVE_TEXT,
        attributes: {
          variant: 'confirm',
          icon: 'play',
          size: 'small',
          'data-testid': 'approve-tool'
        }
      };
    },
    denyAction() {
      return {
        text: this.$options.i18n.DENY_TEXT,
        attributes: {
          variant: 'danger',
          icon: 'cancel',
          size: 'small',
          'data-testid': 'deny-tool'
        }
      };
    },
    toolName() {
      var _this$toolDetails;
      return ((_this$toolDetails = this.toolDetails) === null || _this$toolDetails === void 0 ? void 0 : _this$toolDetails.name) || this.$options.i18n.TOOL_UNKNOWN;
    }
  },
  methods: {
    handleApprove() {
      /**
       * Emitted when the user approves the tool execution
       */
      this.$emit('approve');
    },
    handleDeny() {
      /**
       * Emitted when the user denies the tool execution
       */
      this.$emit('deny');
    },
    handleModalHide(event) {
      // If the modal is being hidden by the X button or ESC key,
      // treat it as a deny-force action
      if (event.trigger !== 'ok' && event.trigger !== 'cancel') {
        this.$emit('deny-force');
      }
    }
  },
  i18n
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-modal',{attrs:{"visible":_vm.visible,"modal-id":"agentic-tool-approval-modal","title":_vm.$options.i18n.TITLE,"action-primary":_vm.approveAction,"action-cancel":_vm.denyAction,"no-close-on-backdrop":true,"no-close-on-esc":true,"data-testid":"agentic-tool-approval-modal"},on:{"primary":_vm.handleApprove,"canceled":_vm.handleDeny,"hide":_vm.handleModalHide}},[_c('div',{staticClass:"gl-mb-4"},[_c('p',{staticClass:"gl-mb-3",attrs:{"data-testid":"approval-description"}},[_vm._v("\n      "+_vm._s(_vm.description)+"\n    ")]),_vm._v(" "),(_vm.toolDetails)?_c('div',{staticClass:"gl-bg-gray-10 gl-p-3 gl-rounded-base gl-mb-3",attrs:{"data-testid":"tool-details"}},[_c('strong',[_vm._v(_vm._s(_vm.$options.i18n.TOOL_LABEL)+" "+_vm._s(_vm.toolName))]),_vm._v(" "),(_vm.toolDetails.parameters)?_c('pre',{staticClass:"gl-mt-2 gl-mb-0 gl-text-inherit",attrs:{"data-testid":"tool-parameters"}},[_vm._v(_vm._s(JSON.stringify(_vm.toolDetails.parameters, null, 2)))]):_vm._e()]):_vm._e()])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
export { i18n };
